module.exports = __webpack_public_path__ + "img/mission-diversity-racial.jpg?a3fdabed2050a95faa742dd2d3d9c8dd";